module.exports = __webpack_public_path__ + "img/seating-cocktail.bf94bcea.svg";